/* eslint-disable react/no-unescaped-entities */
import { Helmet } from 'react-helmet'
import { Button, createStyles, Paper } from '@mantine/core'
import { Link } from 'react-router-dom'
import { Tile } from '../../components/tile'
import { Splash, SplashTitle } from '../../components/splash'
import img1 from '../../assets/large_mof_background.svg'

const useStyles = createStyles((theme) => ({
  h2: {
    fontSize: 24,
    fontWeight: 600,
    marginBottom: theme.spacing.sm,
  },
  list: {
    marginLeft: 24,
    marginBottom: theme.spacing.md,
  },
  quote: {
    fontStyle: 'italic',
    background: theme.colors.gray[9],
    padding: theme.spacing.md,
    borderRadius: theme.radius.md,
    margin: '1.5em 0',
  },
  cta: {
    margin: '2em 0',
    display: 'flex',
    gap: theme.spacing.md,
    flexWrap: 'wrap',
  },
  splashText: {
    h1: {
      [theme.fn.smallerThan('sm')]: {
        fontSize: `${theme.fontSizes.lg * 2}px !important`,
      },
    },
    justifyContent: 'start',
    height: '100%',
  },
  text: {
    padding: '2em 8em',
    [theme.fn.smallerThan('lg')]: {
      padding: '1em 1.5em',
      [theme.fn.smallerThan('sm')]: {
        padding: theme.spacing.sm,
      },
    },
  },
}))

export function SalsaFitnessClasses() {
  const { classes } = useStyles()

  return (
    <main>
      <Helmet>
        <title>Private Salsa Coaching in Coventry | Mistry of Fitness</title>
        <meta
          name='description'
          content='Private one-to-one salsa coaching in Coventry | Tailored sessions for individuals and couples | Accelerated progress with expert guidance | Book your session today →'
        />
      </Helmet>
      <Splash height={'calc(100vh - 56px)'} backgroundSrc={`url(${img1})`}>
        <div className={classes.splashText}>
          <SplashTitle>Private Salsa Coaching in Coventry</SplashTitle>
        </div>
      </Splash>
      <div>
        <Tile tileOpts={{ colour: 'bg-black', accent: 'bg-black', style: 'simple-3' }} mh={200}>
          <div className={classes.text}>
            <h2 className={classes.h2}>Exclusive One-to-One Dance Experience</h2>
            <p>
              At Mistry of Fitness, salsa is no longer a class — it's a personalised experience.
            </p>
            <br />
            <p>
              I offer private, one-to-one salsa coaching in Coventry for individuals and couples who
              want focused attention, accelerated progress, and a refined learning environment.
            </p>
            <br />
            <p>This is for those who value quality over crowds.</p>
            <br />
            <p>
              Whether you are a complete beginner, preparing for a special occasion, or simply want
              to move with confidence and presence, your sessions are designed entirely around you.
            </p>
            <br />
            <p>No group noise.</p>
            <p>No pressure.</p>
            <p>No being overlooked.</p>
            <br />
            <p>Just structured progression, expert guidance, and visible improvement.</p>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'bg-primary', accent: 'brand-primary', style: 'simple-1' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2 className={classes.h2}>Why Choose Private Salsa Coaching?</h2>
            <ul className={classes.list}>
              <li>Fully tailored sessions aligned to your ability and goals</li>
              <li>Accelerated progress with undivided 1–1 attention</li>
              <li>Discreet, comfortable learning environment</li>
              <li>Ideal for professionals, couples, and beginners alike</li>
              <li>Flexible appointment scheduling</li>
              <li>5-star rated coaching experience</li>
            </ul>
            <p>This is premium coaching, not a drop-in dance class.</p>
            <Paper className={classes.quote}>
              "Such an amazing class for everyone at every level. Rik is a fantastic instructor,
              who’s passion for salsa, bachata, reggaeton and other styles, really shines through in
              every single session. Regardless of your level of ability, the class is a warm and
              welcoming space that is great fun and a fantastic workout. Rik alternates sessions
              between partner work and solo work, allowing you to really develop week after week. I
              would 100% recommend this class to every single person who wants to learn how to
              dance, have fun and feel empowered for salsa events. 10/10.”
              <br />
              - Nyasha Mutezo
              <br />
              <a
                href='https://www.google.com/search?num=10&sca_esv=fe7f750ae97d1484&rlz=1C1GCEU_en-GBGB1159GB1160&q=mistry-of-fitness+coventry&nfpr=1&sa=X&ved=2ahUKEwjAoq-wzPqNAxW9UUEAHdLKBvoQvgUoAXoECAwQAg&biw=1920&bih=919&dpr=1&lqi=ChptaXN0cnktb2YtZml0bmVzcyBjb3ZlbnRyeUivr6rZqr2AgAhaLhAAEAEQAhgAGAEYAhgDIhptaXN0cnkgb2YgZml0bmVzcyBjb3ZlbnRyeSoCCAKSARBwZXJzb25hbF90cmFpbmVyqgFSCg0vZy8xMXlicGxwNXloEAEyHxABIhvuBHSH91ZatxdIHH8bVYk9FO0K_uY5kOvj-GoyHhACIhptaXN0cnkgb2YgZml0bmVzcyBjb3ZlbnRyeQ#lkt=LocalPoiReviews&rlimm=1939310020813158845'
                target='_blank'
                rel='noopener noreferrer'
              >
                Read my Google reviews here.
              </a>
            </Paper>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'brand-secondary', accent: 'bg-tertiary', style: 'simple-3' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2 className={classes.h2}>The Experience</h2>
            <p>
              Each session blends authentic Latin technique with posture work, rhythm training,
              controlled movement, and partner fundamentals where appropriate.
            </p>
            <br />
            <p>You will develop:</p>
            <ul className={classes.list}>
              <li>Fluid body movement</li>
              <li>Confident lead or follow technique</li>
              <li>Improved coordination and timing</li>
              <li>Stronger posture and presence</li>
              <li>Greater self-assurance on and off the dance floor</li>
            </ul>
            <p>Progress is measured, structured, and intentional.</p>
            <p>
              Most clients are surprised by how quickly they improve when the attention is entirely
              on them.
            </p>

            <div className={classes.cta}>
              <Button component={Link} to='/contact-faqs' color='brand'>
                Join Now
              </Button>
            </div>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'bg-tertiary', accent: 'brand-primary', style: 'simple-1' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2 className={classes.h2}>Location &amp; Setting</h2>
            <p>
              Sessions take place at Simply Gym, Earl Place, Fletchamstead Hwy, Coventry CV4 9XL — a
              professional, clean, and accessible setting with free parking.
            </p>
            <br />
            <p>Conveniently located next to Costco on the A45.</p>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'brand-tertiary', accent: 'bg-primary', style: 'simple-2' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2 className={classes.h2}>Who This Is For</h2>
            <p>Private salsa coaching is ideal for:</p>
            <ul className={classes.list}>
              <li>Beginners who want to learn properly from the start</li>
              <li>Couples preparing for weddings or events</li>
              <li>Professionals seeking a refined new skill</li>
              <li>Individuals who prefer privacy and focused instruction</li>
              <li>Anyone who values quality over quantity</li>
            </ul>
            <p>
              If you're looking for a loud, crowded group class — this isn't that. If you're looking
              to move with confidence, precision, and style — you're in the right place.
            </p>
            <div className={classes.cta}>
              <Button component={Link} to='/contact-faqs' color='brand'>
                Send Us a Message
              </Button>
            </div>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'bg-secondary', accent: 'brand-primary', style: 'simple-1' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2 className={classes.h2}>Booking</h2>
            <p>
              Private sessions are limited each week to ensure quality and availability. To enquire
              or reserve your session, use the contact form or call directly. Serious enquiries
              only.
            </p>
            <div className={classes.cta}>
              <Button component={Link} to='/contact-faqs' color='brand'>
                Send Us A Message
              </Button>
            </div>
          </div>
        </Tile>
      </div>
    </main>
  )
}
